<template>
    <div>
        <el-form>
            <el-form-item label="上级建筑：">{{data.pathName}}/{{data|placeTypeFormator}}</el-form-item>
        </el-form>

        <el-form :ref="`form${i}`" label-width="0" size="mini" inline v-for="(p,i) in places" :key="i" :model="p">
            <el-row type="flex" justify="space-around" align="middle">
              <el-col>
                <el-form-item prop="name"  label="" :rules="[{required: true, message: '建筑名不能为空'}]">
                    <el-input placeholder="请输入名称" v-model="p.name" :maxlength="20" show-word-limit></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item prop="level"  label="" :rules="[{required: true, message: '类型不能为空'}]">
                    <el-select placeholder="请选择类型" v-model="p.level" >
                        <el-option v-for="item in placeTypeList" :key="i+item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="">
                    <el-button v-if="i===places.length-1" size="mini" type="success" @click="onClickRowAddButton">新增</el-button>
                    <el-button v-if="places.length>1" size="mini" type="danger" @click="onClickRowDeleteButton(i,p)">删除</el-button>
                </el-form-item>
              </el-col>
            </el-row>
        </el-form>
        <el-form>
            <el-form-item>
                <el-button size="mini" @click="onCloseFormButton">取消</el-button>
                <el-button :disabled="!places || places.length<1" size="mini" type="primary" @click="onClickSubmitButton">确定</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import placeManagementInfoApi from '@/api/placeManagement/placeManagementInfo'
export default {
  filters: {
    placeTypeFormator: function (place) {
      if (place && place.name) {
        var suffix = /^[0-9]*$/.test(place.name) ? (['', '单元', '楼层'][place.level]) : ''
        return place.name + suffix
      }
    }
  },
  props: {
    data: {
      type: Object
    },
    showDialog: {
      type: Boolean
    }
  },
  data () {
    return {
      // parent: {},
      placeTypeList: [{ name: '单元', value: 1 }, { name: '楼层', value: 2 }],
      places: [{ level: null, name: null }]
    }
  },
  watch: {
    data: function (newVal, oldVal) {
      if (newVal && newVal instanceof Object) {
        this.parent = newVal
        this.places = [{ level: null, name: null }]
      }
    }
  },
  computed: {
    parent: function () {
      return this.data
    }
  },
  methods: {
    onClickRowDeleteButton (index, rows) {
      // 删除改行
      this.places.splice(index, 1)
    },
    onClickRowAddButton () {
      var last = (this.places && this.places.length > 0) ? this.places[this.places.length - 1] : { level: null }
      var name = null
      if (last.name && !isNaN(parseInt(last.name))) {
        name = parseInt(last.name) + 1
      }
      this.places.push({ level: last.level, name: name })
    },
    /**
     * 处理关闭事件
     */
    onCloseFormButton () {
      this.onClose()
    },
    /**
     * 触发关闭事件
     */
    onClose (rows) {
      // this.data = null
      this.$emit('close', rows)
    },
    onClickSubmitButton () {
      if (this.parent && this.places && this.places.length > 0) {
        var count = 0
        this.places.forEach(p => {
          var i = this.places.indexOf(p)
          var formName = `form${i}`
          this.$refs[formName][0].validate((valid) => {
            if (valid) {
              p.parent = this.data
              count++
            }
          })
        })
        if (count === this.places.length) {
          placeManagementInfoApi.batchInsert(this.places).then(resp => {
            this.$message({ message: '添加成功', type: 'success' })
            // this.parent.children ? this.parent.children.push(...resp.data) : this.parent.children = resp.data
            this.onClose(resp.data)
          })
        }
      }
    }
  }
}
</script>
